var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-header-user"},[_c('i',{staticClass:"mag-icon-nav-top-user"}),_c('span',[_vm._v(" "+_vm._s(_vm.user.name)+" "+_vm._s(_vm.user.fullName)+" ("+_vm._s(_vm.user.departmentName)+") ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }